import _regeneratorRuntime from "@babel/runtime/regenerator";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import { DataErrorCheckoutTypes } from "@sdk/api/Checkout/types";
export var CheckoutJobs = function CheckoutJobs(repository, networkManager) {
  var _this = this;

  _classCallCheck(this, CheckoutJobs);

  this.createCheckout =
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(_ref) {
      var email, lines, shippingAddress, selectedShippingAddressId, billingAddress, selectedBillingAddressId, cartPromoCode, _ref3, data, error;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              email = _ref.email, lines = _ref.lines, shippingAddress = _ref.shippingAddress, selectedShippingAddressId = _ref.selectedShippingAddressId, billingAddress = _ref.billingAddress, selectedBillingAddressId = _ref.selectedBillingAddressId, cartPromoCode = _ref.cartPromoCode;
              _context.next = 3;
              return _this.networkManager.createCheckout(email, lines, shippingAddress, billingAddress);

            case 3:
              _ref3 = _context.sent;
              data = _ref3.data;
              error = _ref3.error;

              if (!error) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", {
                dataError: {
                  error: error,
                  type: DataErrorCheckoutTypes.SET_SHIPPING_ADDRESS
                }
              });

            case 8:
              _this.repository.setCheckout(_objectSpread({}, data, {
                cartPromoCode: cartPromoCode,
                selectedBillingAddressId: selectedBillingAddressId,
                selectedShippingAddressId: selectedShippingAddressId
              }));

              return _context.abrupt("return", {
                data: data
              });

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  this.setShippingAddress =
  /*#__PURE__*/
  function () {
    var _ref5 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(_ref4) {
      var checkoutId, shippingAddress, email, selectedShippingAddressId, checkout, _ref6, data, error;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              checkoutId = _ref4.checkoutId, shippingAddress = _ref4.shippingAddress, email = _ref4.email, selectedShippingAddressId = _ref4.selectedShippingAddressId;
              checkout = _this.repository.getCheckout();
              _context2.next = 4;
              return _this.networkManager.setShippingAddress(shippingAddress, email, checkoutId);

            case 4:
              _ref6 = _context2.sent;
              data = _ref6.data;
              error = _ref6.error;

              if (!error) {
                _context2.next = 9;
                break;
              }

              return _context2.abrupt("return", {
                dataError: {
                  error: error,
                  type: DataErrorCheckoutTypes.SET_SHIPPING_ADDRESS
                }
              });

            case 9:
              _this.repository.setCheckout(_objectSpread({}, checkout, {
                billingAsShipping: false,
                email: data === null || data === void 0 ? void 0 : data.email,
                selectedShippingAddressId: selectedShippingAddressId,
                shippingAddress: data === null || data === void 0 ? void 0 : data.shippingAddress
              }));

              return _context2.abrupt("return", {
                data: data
              });

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref5.apply(this, arguments);
    };
  }();

  this.setBillingAddress =
  /*#__PURE__*/
  function () {
    var _ref8 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3(_ref7) {
      var checkoutId, billingAddress, billingAsShipping, selectedBillingAddressId, checkout, _ref9, data, error;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              checkoutId = _ref7.checkoutId, billingAddress = _ref7.billingAddress, billingAsShipping = _ref7.billingAsShipping, selectedBillingAddressId = _ref7.selectedBillingAddressId;
              checkout = _this.repository.getCheckout();
              _context3.next = 4;
              return _this.networkManager.setBillingAddress(billingAddress, checkoutId);

            case 4:
              _ref9 = _context3.sent;
              data = _ref9.data;
              error = _ref9.error;

              if (!error) {
                _context3.next = 9;
                break;
              }

              return _context3.abrupt("return", {
                dataError: {
                  error: error,
                  type: DataErrorCheckoutTypes.SET_BILLING_ADDRESS
                }
              });

            case 9:
              _this.repository.setCheckout(_objectSpread({}, checkout, {
                billingAddress: data === null || data === void 0 ? void 0 : data.billingAddress,
                billingAsShipping: !!billingAsShipping,
                promoCodeDiscount: data === null || data === void 0 ? void 0 : data.promoCodeDiscount,
                selectedBillingAddressId: selectedBillingAddressId
              }));

              return _context3.abrupt("return", {
                data: data
              });

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref8.apply(this, arguments);
    };
  }();

  this.setNotes =
  /*#__PURE__*/
  function () {
    var _ref11 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4(_ref10) {
      var checkoutId, notes, checkout, _ref12, data, error;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              checkoutId = _ref10.checkoutId, notes = _ref10.notes;
              checkout = _this.repository.getCheckout();
              _context4.next = 4;
              return _this.networkManager.setNotes(notes, checkoutId);

            case 4:
              _ref12 = _context4.sent;
              data = _ref12.data;
              error = _ref12.error;

              if (!error) {
                _context4.next = 9;
                break;
              }

              return _context4.abrupt("return", {
                dataError: {
                  error: error,
                  type: DataErrorCheckoutTypes.SET_NOTES
                }
              });

            case 9:
              _this.repository.setCheckout(_objectSpread({}, checkout, {
                deliveryNote: data === null || data === void 0 ? void 0 : data.deliveryNote,
                note: data === null || data === void 0 ? void 0 : data.note
              }));

              return _context4.abrupt("return", {
                data: data
              });

            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref11.apply(this, arguments);
    };
  }();

  this.setBillingAddressWithEmail =
  /*#__PURE__*/
  function () {
    var _ref14 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee5(_ref13) {
      var checkoutId, email, billingAddress, selectedBillingAddressId, checkout, _ref15, data, error;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              checkoutId = _ref13.checkoutId, email = _ref13.email, billingAddress = _ref13.billingAddress, selectedBillingAddressId = _ref13.selectedBillingAddressId;
              checkout = _this.repository.getCheckout();
              _context5.next = 4;
              return _this.networkManager.setBillingAddressWithEmail(billingAddress, email, checkoutId);

            case 4:
              _ref15 = _context5.sent;
              data = _ref15.data;
              error = _ref15.error;

              if (!error) {
                _context5.next = 9;
                break;
              }

              return _context5.abrupt("return", {
                dataError: {
                  error: error,
                  type: DataErrorCheckoutTypes.SET_BILLING_ADDRESS
                }
              });

            case 9:
              _this.repository.setCheckout(_objectSpread({}, checkout, {
                billingAddress: data === null || data === void 0 ? void 0 : data.billingAddress,
                billingAsShipping: false,
                email: data === null || data === void 0 ? void 0 : data.email,
                selectedBillingAddressId: selectedBillingAddressId
              }));

              return _context5.abrupt("return", {
                data: data
              });

            case 11:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x5) {
      return _ref14.apply(this, arguments);
    };
  }();

  this.setShippingMethod =
  /*#__PURE__*/
  function () {
    var _ref17 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee6(_ref16) {
      var checkoutId, shippingMethodId, checkout, _ref18, data, error;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              checkoutId = _ref16.checkoutId, shippingMethodId = _ref16.shippingMethodId;
              checkout = _this.repository.getCheckout();
              _context6.next = 4;
              return _this.networkManager.setShippingMethod(shippingMethodId, checkoutId);

            case 4:
              _ref18 = _context6.sent;
              data = _ref18.data;
              error = _ref18.error;

              if (!error) {
                _context6.next = 9;
                break;
              }

              return _context6.abrupt("return", {
                dataError: {
                  error: error,
                  type: DataErrorCheckoutTypes.SET_SHIPPING_METHOD
                }
              });

            case 9:
              _this.repository.setCheckout(_objectSpread({}, checkout, {
                promoCodeDiscount: data === null || data === void 0 ? void 0 : data.promoCodeDiscount,
                shippingMethod: data === null || data === void 0 ? void 0 : data.shippingMethod
              }));

              return _context6.abrupt("return", {
                data: data
              });

            case 11:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x6) {
      return _ref17.apply(this, arguments);
    };
  }();

  this.addPromoCode =
  /*#__PURE__*/
  function () {
    var _ref20 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee7(_ref19) {
      var checkoutId, promoCode, checkout, _ref21, data, error;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              checkoutId = _ref19.checkoutId, promoCode = _ref19.promoCode;
              checkout = _this.repository.getCheckout();
              _context7.next = 4;
              return _this.networkManager.addPromoCode(promoCode, checkoutId);

            case 4:
              _ref21 = _context7.sent;
              data = _ref21.data;
              error = _ref21.error;

              if (!error) {
                _context7.next = 9;
                break;
              }

              return _context7.abrupt("return", {
                dataError: {
                  error: error,
                  type: DataErrorCheckoutTypes.ADD_PROMO_CODE
                }
              });

            case 9:
              _this.repository.setCheckout(_objectSpread({}, checkout, {
                promoCodeDiscount: data === null || data === void 0 ? void 0 : data.promoCodeDiscount
              }));

              return _context7.abrupt("return", {
                data: data
              });

            case 11:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x7) {
      return _ref20.apply(this, arguments);
    };
  }();

  this.removePromoCode =
  /*#__PURE__*/
  function () {
    var _ref23 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee8(_ref22) {
      var checkoutId, promoCode, checkout, _ref24, data, error;

      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              checkoutId = _ref22.checkoutId, promoCode = _ref22.promoCode;
              checkout = _this.repository.getCheckout();
              _context8.next = 4;
              return _this.networkManager.removePromoCode(promoCode, checkoutId);

            case 4:
              _ref24 = _context8.sent;
              data = _ref24.data;
              error = _ref24.error;

              if (!error) {
                _context8.next = 9;
                break;
              }

              return _context8.abrupt("return", {
                dataError: {
                  error: error,
                  type: DataErrorCheckoutTypes.REMOVE_PROMO_CODE
                }
              });

            case 9:
              _this.repository.setCheckout(_objectSpread({}, checkout, {
                promoCodeDiscount: data === null || data === void 0 ? void 0 : data.promoCodeDiscount
              }));

              return _context8.abrupt("return", {
                data: data
              });

            case 11:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function (_x8) {
      return _ref23.apply(this, arguments);
    };
  }();

  this.createPayment =
  /*#__PURE__*/
  function () {
    var _ref26 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee9(_ref25) {
      var checkoutId, amount, paymentGateway, paymentToken, billingAddress, creditCard, payment, _ref27, data, error;

      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              checkoutId = _ref25.checkoutId, amount = _ref25.amount, paymentGateway = _ref25.paymentGateway, paymentToken = _ref25.paymentToken, billingAddress = _ref25.billingAddress, creditCard = _ref25.creditCard;
              payment = _this.repository.getPayment();
              _context9.next = 4;
              return _this.networkManager.createPayment(amount, checkoutId, paymentGateway, paymentToken, billingAddress);

            case 4:
              _ref27 = _context9.sent;
              data = _ref27.data;
              error = _ref27.error;

              if (!error) {
                _context9.next = 9;
                break;
              }

              return _context9.abrupt("return", {
                dataError: {
                  error: error,
                  type: DataErrorCheckoutTypes.CREATE_PAYMENT
                }
              });

            case 9:
              _this.repository.setPayment(_objectSpread({}, payment, {
                creditCard: creditCard,
                gateway: data === null || data === void 0 ? void 0 : data.gateway,
                id: data === null || data === void 0 ? void 0 : data.id,
                token: data === null || data === void 0 ? void 0 : data.token
              }));

              return _context9.abrupt("return", {
                data: data
              });

            case 11:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function (_x9) {
      return _ref26.apply(this, arguments);
    };
  }();

  this.completeCheckout =
  /*#__PURE__*/
  function () {
    var _ref29 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee10(_ref28) {
      var checkoutId, _ref30, data, error;

      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              checkoutId = _ref28.checkoutId;
              _context10.next = 3;
              return _this.networkManager.completeCheckout(checkoutId);

            case 3:
              _ref30 = _context10.sent;
              data = _ref30.data;
              error = _ref30.error;

              if (!error) {
                _context10.next = 8;
                break;
              }

              return _context10.abrupt("return", {
                dataError: {
                  error: error,
                  type: DataErrorCheckoutTypes.COMPLETE_CHECKOUT
                }
              });

            case 8:
              // this.repository.setOrder(data);
              _this.repository.setCheckout({});

              _this.repository.setPayment({});

              return _context10.abrupt("return", {
                data: data
              });

            case 11:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function (_x10) {
      return _ref29.apply(this, arguments);
    };
  }();

  this.networkManager = networkManager;
  this.repository = repository;
};